// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.10.0_webpack@5.90.3/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.10.0_webpack@5.90.3/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/.pnpm/css-loader@6.10.0_webpack@5.90.3/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../node_modules/.pnpm/postcss-loader@8.1.1_postcss@8.4.35_typescript@3.9.10_webpack@5.90.3/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!../../../containers/Auth/Auth.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Vofat{}.GKHvr{}.ZlfAS{}.sKVWZ{}.twZHh{}.n_yOL{}.jic8t{}.zcRNq{}.mITAN{}.qRQqm{}.vSWfn{}.GZit3{}.cbHkK{font-size:1.25rem;margin-top:20px;line-height:1.3;font-weight:300}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `Vofat ${___CSS_LOADER_ICSS_IMPORT_0___.locals["title"]}`,
	"form": `GKHvr ${___CSS_LOADER_ICSS_IMPORT_0___.locals["form"]}`,
	"row": `ZlfAS ${___CSS_LOADER_ICSS_IMPORT_0___.locals["row"]}`,
	"responseError": `sKVWZ ${___CSS_LOADER_ICSS_IMPORT_0___.locals["responseError"]}`,
	"input": `twZHh ${___CSS_LOADER_ICSS_IMPORT_0___.locals["input"]}`,
	"buttons": `n_yOL ${___CSS_LOADER_ICSS_IMPORT_0___.locals["buttons"]}`,
	"checkbox": `jic8t ${___CSS_LOADER_ICSS_IMPORT_0___.locals["checkbox"]}`,
	"socials": `zcRNq ${___CSS_LOADER_ICSS_IMPORT_0___.locals["socials"]}`,
	"socialsIcons": `mITAN ${___CSS_LOADER_ICSS_IMPORT_0___.locals["socialsIcons"]}`,
	"socialsIcon": `qRQqm ${___CSS_LOADER_ICSS_IMPORT_0___.locals["socialsIcon"]}`,
	"socialsTitle": `vSWfn ${___CSS_LOADER_ICSS_IMPORT_0___.locals["socialsTitle"]}`,
	"back": `GZit3 ${___CSS_LOADER_ICSS_IMPORT_0___.locals["link"]}`,
	"successMessage": `cbHkK`
};
export default ___CSS_LOADER_EXPORT___;
